import { StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'

import { SurveyReportConclusion } from '../../../../api/services/user_assignment_codes/types.ts'
import { getScoreRangeIndex } from '../handlers.ts'

export const SIGNALS = [
  {
    color: '#008f00',
    title: 'Słaby sygnał',
    min_score: 0,
    max_score: 29.99,
    gradientColors: [
      '#008f00',
      '#26a326',
      '#4db84d',
      '#73c973',
      '#95d695',
      '#b8e4b8',
      '#daf1da'
    ]
  },
  {
    color: '#c89a08',
    title: 'Umiarkowany sygnał',
    min_score: 30,
    max_score: 49.99,
    gradientColors: [
      '#c89a08',
      '#d3ab31',
      '#debd5a',
      '#e9ce83',
      '#efdb9f',
      '#f5e7bb',
      '#fbf3d7'
    ]
  },
  {
    color: '#922020',
    title: 'Silny sygnał',
    min_score: 50,
    max_score: 100,
    gradientColors: [
      '#922020',
      '#a0302a',
      '#ae4033',
      '#bc5140',
      '#ca6550',
      '#da8a6a',
      '#e8b088'
    ]
  }
]

type Props = {
  conclusion: SurveyReportConclusion | undefined
  total: number | undefined
}
const Signals = (props: Props) => {
  if (!props || !props.conclusion || !props.total) return null

  const percentage =
    (Math.round((props.conclusion.patient_count / props.total) * 100) * 100) /
    100

  const index = getScoreRangeIndex(SIGNALS, percentage)
  const gradient = SIGNALS[index].gradientColors

  return (
    <View style={styles.wrapper}>
      <Text style={styles.title}>{props.conclusion.title}</Text>
      <Text style={[styles.percentage, { color: SIGNALS[index].color }]}>
        {percentage}{' '}
        <Text style={{ fontSize: 18, fontWeight: 'normal' }}>%</Text>
      </Text>

      <View style={[styles.signal, {}]}>
        <Text
          style={[
            styles.signalDescription,
            { backgroundColor: SIGNALS[index].color }
          ]}
        >
          {SIGNALS[index].title}
        </Text>

        <View style={styles.gradientBar}>
          {gradient.map((color, index) => (
            <View
              key={`${color}-${index}`}
              style={[styles.gradientStep, { backgroundColor: color }]}
            />
          ))}
        </View>
      </View>
      <Text style={styles.text}>{props.conclusion?.text}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    width: '49%',
    flexShrink: 0,
    marginHorizontal: 0,
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#bababa',
    padding: 12
  },
  title: {
    fontSize: 13,
    fontFamily: 'Sora'
  },
  percentage: {
    fontSize: 24,
    fontFamily: 'NotoSans',
    fontWeight: 'bold'
  },
  signal: {
    flexDirection: 'row'
  },
  signalDescription: {
    marginRight: 1,
    paddingHorizontal: 10,
    paddingVertical: 6,
    fontSize: 10,
    fontFamily: 'NotoSans',
    fontWeight: 'bold',
    color: 'white'
  },
  text: {
    marginTop: 10,
    fontSize: 10,
    fontFamily: 'NotoSans',
    lineHeight: 1.2
  },
  gradientBar: {
    flexGrow: 1,
    flexShrink: 1,
    flexDirection: 'row',
    height: 20
  },

  gradientStep: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0
  },
  test: {
    color: '#c89a08'
  }
})

export default React.memo(Signals)
